<template>
  <ReportPageLayout>
    <v-container class="px-4">
      <v-responsive max-width="1320" class="mx-auto">
        <ReportsHeader
          :total="reportsStore.totalItems"
          @sort-change="handleSortChange"
        />
        <v-row>
          <v-col cols="12" md="2" class="pr-md-1">
            <ReportsSidebar />
          </v-col>

          <v-col cols="12" md="10">
            <ReportsCardsList />
          </v-col>
        </v-row>
      </v-responsive>
    </v-container>
    <ReportCompareBar />
  </ReportPageLayout>
</template>

<script setup lang="ts">
  import { useReportsStore } from '../store';
  import { onMounted } from 'vue';

  // Import reports components
  import ReportsHeader from '../components/reports/ReportsHeader.vue';
  import ReportsSidebar from '../components/reports/ReportsSidebar.vue';
  import ReportsCardsList from '../components/reports/ReportsCardsList.vue';

  // Import other feature components
  import ReportPageLayout from '../layouts/ReportPageLayout.vue';
  import ReportCompareBar from '../components/compare/ReportCompareBar.vue';

  const reportsStore = useReportsStore();

  // Ensure data is loaded if not already initialized elsewhere
  onMounted(async () => {
    if (reportsStore.filters.length === 0) {
      await reportsStore.fetchFilters();
    }

    if (reportsStore.reports.length === 0) {
      await reportsStore.fetchReports();
    }
  });

  function handleSortChange(option: string) {
    reportsStore.setSortOption(option);
  }
</script>

<style scoped>
  .v-responsive {
    padding-right: 0;
  }
</style>
